import { Alert, AlertTitle, Typography, Box } from '@mui/material';
import React from 'react';
import { ReferenceArrayInput, SelectArrayInput } from 'react-admin';
import { Tooltip } from '../../../components';

const FormCustomerGroup: React.FC<{ formData?: any }> = ({ formData }) => (
  <>
    {formData?.type === 'special'
      && (formData?.fuelScorings?.length ?? 0) > 0
      && formData.fuelScorings.every((fs: any) => !fs.factor) ? (
      <Alert severity="warning" sx={{ mb: 2 }}>
        <AlertTitle>Pontuação zerada</AlertTitle>
        Todos os fatores estão em <strong>0</strong>. Selecione abaixo o grupo específico (etiqueta de clientes
        ou clientes) para que a pontuação seja zerada <strong>apenas</strong> para esse grupo. Sem segmentação,
        a regra com factor <strong>0</strong> não é permitida.
      </Alert>
    ) : null}
    <Tooltip title="Selecione etiquetas de clientes para aplicar a pontuação" placement="top-start" sxContainer={{ alignItems: 'flex-start' }}>
      <Box display="flex" alignItems="center">
        <ReferenceArrayInput
          sort={{ field: 'name', order: 'ASC' }}
          filter={{ type: 'client' }}
          perPage={9999}
          source="customerTagIds"
          reference="chains/chainId/tag"
        >
          <SelectArrayInput
            label="Etiquetas de clientes"
            optionText="name"
            disabled={!!formData?.customerIds}
            sx={{ width: 300 }}
          />
        </ReferenceArrayInput>
      </Box>
    </Tooltip>
    {formData?.customerIds && (
      <Typography sx={{ mt: 2 }}>Há {formData.customerIds.length} clientes selecionados para essa pontuação</Typography>
    )}
  </>
);

export default FormCustomerGroup;
